import React,{useState} from "react";
import MUITypography from "../../Components/MUITypography";
import EditIcon from "@mui/icons-material/Edit";
import FormFieldValues from "../../Components/Custom/FormFieldValues";
import { ACCESS_RESTRICTED_MESSAGE, ADDRESS, CITY, COUNTRY, CURRENCY, EMAIL, GST_BUSINESS_LABEL, MOBILE, PINCODE, SESSION_USER_ROLES_PERMISSIONS, STATE,  VENUE_NAME, VENUE_TYPE, WEBSITE_URL } from "../../Util/VMConstants";
import { Box, Card, CardContent, Dialog, DialogContent,  Grid, IconButton } from "@mui/material";
import UpdateVenueRegistration from "./UpdateVenueRegistration";
import { checkIsPermissionExist, isEmpty } from "../../Util/UtilHelper";
import StorageFactory from "../../Util/StorageFactory";
import NoPermission from "../../Components/NoPermission";


function UpdateVenueDetails(props) {
  const {venueState,loadProfile,editable} = props;
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const sessionFactory = new StorageFactory('session');
  const VM_PERMISSIONS = sessionFactory.get(SESSION_USER_ROLES_PERMISSIONS);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: 1,
          flexWrap: "wrap",
        }}
      >
        <MUITypography label="Venue Details" variant="h4" gutterBottom   sx={{   fontWeight: 700, color: '#1E1E1E' }}/>

        { checkIsPermissionExist(VM_PERMISSIONS,'VM020') && editable && 
          <IconButton
            aria-label="edit"
            onClick={handleOpen}
            sx={{
              width: "auto", // Prevents 100% width
              alignSelf: "flex-start", // Aligns at top if needed
            }}
          >
            <EditIcon />
          </IconButton>
        }
      </Box>

       {
        checkIsPermissionExist(VM_PERMISSIONS,'VM014') 
        ?
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={5} fullWidth>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={VENUE_NAME} subtitle={venueState.venue_name} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={VENUE_TYPE} subtitle={venueState.venue_type} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={MOBILE} subtitle={ venueState.country_code+" "+venueState.venue_mobile_no} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={EMAIL} subtitle={venueState.venue_email} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={CURRENCY} subtitle={venueState.currency} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={COUNTRY} subtitle={venueState.country_name} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={STATE} subtitle={venueState.state_name} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={CITY} subtitle={venueState.city_name} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={ADDRESS} subtitle={venueState.address} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={PINCODE} subtitle={venueState.pincode} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={GST_BUSINESS_LABEL}  subtitle={venueState.business_label} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <FormFieldValues title={WEBSITE_URL} subtitle={isEmpty(venueState.website_url)?"NA":venueState.website_url} />
              </Grid>

            </Grid>
          </Box>
        </CardContent>
      </Card>
      :  <Box sx={{ mt: 4 }}>
            <NoPermission message={ACCESS_RESTRICTED_MESSAGE} />  
        </Box>
       } 


       {/* Dialog for UserRegistration Form */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        {/* <DialogTitle>Edit Personal Details</DialogTitle> */}
        <DialogContent>
          {/* <UpdateUserRegistration venueState={venueState} onClose={handleClose}/> */}
       
          <UpdateVenueRegistration purpose={"update"} venueState={venueState} onClose={handleClose} loadProfile={loadProfile}/>
        </DialogContent>
      </Dialog>

    </Box>
  )
}

export default UpdateVenueDetails